import { SET_TITLE } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function setTitle(state: State, action: Action): State {
	if (action.type !== SET_TITLE) {
		return state
	}
	const newConversationList = state.conversationList.map(conversation => {
		if (
			action.editOrCreate === 'edit' &&
			conversation.id === action.conversationId
		) {
			return {
				...conversation,
				title: action.title,
				updatedAt: new Date().toISOString(),
			}
		}

		if (
			action.editOrCreate === 'create' &&
			conversation.id === state.conversationId
		) {
			return {
				...conversation,
				title: action.title,
			}
		}
		return conversation
	})

	return {
		...state,
		conversationList: newConversationList,
		titleHasBeenSet: true,
	}
}
